// extracted by mini-css-extract-plugin
export const card = "styles-module--card--jtJQC";
export const titleSection = "styles-module--titleSection--su9V9";
export const txtName = "styles-module--txtName---l9tf";
export const txtTitle = "styles-module--txtTitle--VgdE+";
export const txtChanged = "styles-module--txtChanged--c0Jfc";
export const divCategory = "styles-module--divCategory--BaI6i";
export const txtCategory = "styles-module--txtCategory--BmLFO";
export const txtReward = "styles-module--txtReward--+hvsd";
export const categoryContainer = "styles-module--categoryContainer--9gVWs";